import { Entity } from "./Entity";

export class UploadTicket extends Entity {
  id = 0;

  constructor() {
    super();
  }

  fileBase64: File;
  ticketTypesId;
  errors: string[] = null;
  ticketCutoffType: string;
}
